module.exports = __webpack_public_path__ + "static/media/banner-home-1.671c81f6.jpg";